<template>
	<div style="flex: 1; background-color: red">
		<p>Pagina di prova della pivot nuova</p>
		<Pivot class="sa-test-test" :data="data" v-model="fields" :showSettings="defaultShowSettings"> </Pivot>
	</div>
</template>

<script>
import { Pivot } from "vue-pivot-table-plus";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
	mixins: [UtilityMixin],
	components: { Pivot },
	data() {
		return {
			data: [
				{
					COGNOME: "CONTE",
					NOME: "GUIDO",
					CODFISCALE: "CNTGDU50M28D801J",
					DATANASCITA: -610502400000,
					DATAOKANESTESIOLOGICO: null,
					ANNOPREOSP: null,
					PROGPREOSP: null,
					CODINTERVENTO: "9925",
					DESBINTERVENTO: "Iniezione o infusione di sostanze chemioterapiche",
					CODPRIORITA: "A",
					UPPER: null,
					DATAPRENOTAZIONE: 1708300800000,
					DATARICOVERO: 1708300800000,
					SUBTRACT: 0,
				},
				{
					COGNOME: "DEL PRETE",
					NOME: "GIUSEPPE",
					CODFISCALE: "DLPGPP39R03D789V",
					DATANASCITA: -954547200000,
					DATAOKANESTESIOLOGICO: 1731369600000,
					ANNOPREOSP: "2024",
					PROGPREOSP: 2682,
					CODINTERVENTO: "5749",
					DESBINTERVENTO: "Altra resezione transuretrale di lesione vescicale",
					CODPRIORITA: "A",
					UPPER: "FERDINANDO FUSCO",
					DATAPRENOTAZIONE: 1713744000000,
					DATARICOVERO: 1731369600000,
					SUBTRACT: 204,
				},
				{
					COGNOME: "DEL PRETE",
					NOME: "GIUSEPPE",
					CODFISCALE: "DLPGPP39R03D789V",
					DATANASCITA: -954547200000,
					DATAOKANESTESIOLOGICO: 1731369600000,
					ANNOPREOSP: "2024",
					PROGPREOSP: 2682,
					CODINTERVENTO: "6029",
					DESBINTERVENTO: null,
					CODPRIORITA: "A",
					UPPER: "FERDINANDO FUSCO",
					DATAPRENOTAZIONE: 1713744000000,
					DATARICOVERO: 1731369600000,
					SUBTRACT: 204,
				},
				{
					COGNOME: "DE ROSA",
					NOME: "BRUNO",
					CODFISCALE: "DRSBRN39E31B963R",
					DATANASCITA: -965347200000,
					DATAOKANESTESIOLOGICO: null,
					ANNOPREOSP: null,
					PROGPREOSP: null,
					CODINTERVENTO: "9925",
					DESBINTERVENTO: "Iniezione o infusione di sostanze chemioterapiche",
					CODPRIORITA: "A",
					UPPER: null,
					DATAPRENOTAZIONE: 1742774400000,
					DATARICOVERO: 1742860800000,
					SUBTRACT: 1,
				},
			],
			fields: {
				availableFields: [
					{
						getter: (item) => item.COGNOME,
						label: "COGNOME",
					},
					{
						getter: (item) => item.NOME,
						label: "NOME",
					},
					{
						getter: (item) => item.stato,
						label: "Stato",
					},
					{
						getter: (item) => item.sezione,
						label: "Sezione",
					},
					{
						getter: (item) => item.DATARICOVERO,
						label: "DATARICOVERO",
					},
				],
				rowFields: [],
				colFields: [
					// {
					// 	getter: (item) => item.CODFISCALE,
					// 	label: "CODFISCALE",
					// },
				],
				fieldsOrder: {},
			},
			//reducer: (sum) => sum + 1,
			defaultShowSettings: true,
		};
	},
	mounted() {
		console.log("Tutto Vediamo");
		this.loadData();
	},
	methods: {
		loadData() {
			//http://localhost:8081/api/logs?language=it&dataDal=1748728800000&dataAl=1751666400000&sezione=&username=&evento=&ip=&page=1&forPage=50
			//UtilityMixin.methods.loadDataResources("/logs?language=it&dataDal=1748728800000&dataAl=1751666400000&sezione=&username=&evento=&ip=&page=1&forPage=50", {}, this.loadDataSuccess, this.loadDataError);
		},
		loadDataSuccess(response) {
			console.log(response);
			this.data = Object.freeze(response.data.data);
		},
		loadDataError(error) {
			console.log(error);
		},
	},
};
</script>

<style></style>
